/* Category description enhancement. Native server HTML is readable without JS. */
(() => {
  const bind = (root) => {
    if (root.dataset.pdpBound) return;
    root.dataset.pdpBound = 'true';
    const tabs = [...root.querySelectorAll('[data-pdp-tab]')];
    const toggles = [...root.querySelectorAll('[data-pdp-toggle]')];
    const panels = [...root.querySelectorAll('[data-pdp-panel]')];
    const tablist = root.querySelector('[data-pdp-tabs]');
    if (tabs.length !== 6 || toggles.length !== tabs.length || panels.length !== tabs.length) return;
    const media = matchMedia('(min-width: 992px)');
    const home = root.parentElement;
    const slot = document.querySelector('[data-pdp-desktop-slot]');
    const mount = () => {
      if (slot && media.matches) slot.append(root);
      else if (root.parentElement !== home) home.append(root);
    };
    mount();
    const details = document.querySelector('[data-bk-pdp-main] .bls__product-details-infor');
    // Move the existing DOM nodes together; native IDs, values and event
    // handlers survive. This avoids duplicate forms or variant synchronisation.
    const nativePrice = details?.querySelector('.bls__product-price');
    const nativeFormBlock = details?.querySelector('#product-form');
    const directChild = node => {
      while (node && node.parentElement !== details) node = node.parentElement;
      return node;
    };
    const start = directChild(nativePrice), end = directChild(nativeFormBlock);
    let buy;
    if (start && end && (start.compareDocumentPosition(end) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      buy = document.createElement('div');
      buy.className = 'bk-pdp-buy'; buy.dataset.pdpBuy = '';
      start.before(buy);
      for (let node = start; node;) {
        const next = node.nextSibling; buy.append(node);
        if (node === end) break;
        node = next;
      }
      details.closest('[data-bk-pdp-main]').classList.add('bk-pdp-buy-ready');
    }
    // Only price, variant controls, the original purchase form and its delivery
    // reassurance belong in the pinned group. Keep the same live DOM nodes.
    if (buy) {
      const followup = document.createElement('div');
      followup.className = 'bk-pdp-buy-followup';
      const offer = buy.querySelector('.bk-purchase__offer');
      if (offer) followup.append(offer);
      const purchaseForm = nativeFormBlock.querySelector('product-form');
      if (purchaseForm) {
        while (purchaseForm.nextSibling) followup.append(purchaseForm.nextSibling);
      }
      if (followup.childNodes.length) buy.after(followup);
    }
    // Trustoo can asynchronously insert customer photos after the native form.
    // That form now lives in the sticky group, so move only support widgets back
    // into the ordinary sidebar flow. Preserve the actual form and variant nodes.
    const keepSupportInFlow = () => {
      if (!buy) return;
      const supportSelector = '.trustoo-widget,.bk-guide-promo,.bk-pdp-support,.bk-pdp-reco';
      let anchor = buy;
      [...buy.children].filter(node =>
        (node.matches(supportSelector) || node.querySelector(supportSelector)) &&
        !node.matches('product-form,variant-selects,.bls__product-price') &&
        !node.querySelector('product-form,variant-selects,.bls__product-price')
      ).forEach(node => { anchor.after(node); anchor = node; });
    };
    keepSupportInFlow();
    const updateReviews = () => details?.querySelectorAll('.trustoo-widget .tt-swiper-container').forEach(el => {
      if (!el.swiper?.destroyed && typeof el.swiper?.update === 'function') el.swiper.update();
    });
    let reviewWidth = 0;
    const reviewResize = new ResizeObserver(() => {
      const width = details?.getBoundingClientRect().width || 0;
      if (width !== reviewWidth) { reviewWidth = width; updateReviews(); }
    });
    if (details) reviewResize.observe(details);
    const reviewInsert = new MutationObserver(records => {
      keepSupportInFlow();
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.trustoo-widget,.tt-swiper-container') || node.querySelector('.trustoo-widget,.tt-swiper-container'))))) updateReviews();
    });
    if (details) reviewInsert.observe(details, { childList: true, subtree: true });
    let desktop = media.matches;
    let selected = 0;
    const expanded = new Set([0]);
    let destroyed = false;
    const signalController = new AbortController();
    const options = { signal: signalController.signal };
    let buyFrame = 0, buyTrackUntil = 0;
    const updateBuy = () => {
      buyFrame = 0;
      if (!buy) return;
      const header = document.querySelector('#sticky-header')?.getBoundingClientRect();
      const top = (header && header.top <= 1 && header.bottom > 0 ? header.bottom : 0) + 10;
      buy.style.setProperty('--pdp-buy-top', `${top}px`);
      // Tall option lists and browser zoom must never trap controls off screen.
      buy.classList.toggle('bk-pdp-buy--fits', buy.getBoundingClientRect().height + top + 12 <= innerHeight);
      // The native header slides into place after the scroll event itself.
      if (performance.now() < buyTrackUntil) buyFrame = requestAnimationFrame(updateBuy);
    };
    const scheduleBuy = () => {
      buyTrackUntil = performance.now() + 500;
      if (!buyFrame) buyFrame = requestAnimationFrame(updateBuy);
    };
    const buyResize = new ResizeObserver(scheduleBuy);
    if (buy) buyResize.observe(buy);
    const nativeHeader = document.querySelector('#sticky-header');
    if (nativeHeader) buyResize.observe(nativeHeader);
    window.addEventListener('scroll', scheduleBuy, { ...options, passive: true });
    window.addEventListener('resize', scheduleBuy, options);
    scheduleBuy();
    const render = () => {
      root.classList.add('is-enhanced');
      root.classList.toggle('is-mobile', !desktop);
      if (desktop) tablist.setAttribute('role', 'tablist');
      else tablist.removeAttribute('role');
      tabs.forEach((tab, i) => {
        if (desktop) {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panels[i].id);
          tab.setAttribute('aria-selected', String(i === selected));
          tab.tabIndex = i === selected ? 0 : -1;
        } else {
          tab.removeAttribute('role');
          tab.removeAttribute('aria-selected');
          tab.removeAttribute('aria-controls');
          tab.tabIndex = -1;
        }
        const visible = desktop ? i === selected : expanded.has(i);
        panels[i].hidden = !visible;
        panels[i].setAttribute('role', desktop ? 'tabpanel' : 'region');
        panels[i].setAttribute('aria-labelledby', desktop ? tab.id : toggles[i].id);
        // A text-only tab panel is reachable from the keyboard too.
        if (desktop) panels[i].tabIndex = 0;
        else panels[i].removeAttribute('tabindex');
        toggles[i].setAttribute('aria-expanded', String(visible));
        toggles[i].querySelector('span').textContent = visible ? '−' : '+';
      });
    };
    // Native predictive search handles every document keyup and resets the first
    // aria-selected control. Keep keyboard events within this independent region.
    root.addEventListener('keyup', event => event.stopPropagation(), options);
    // The inherited search handler also changes ARIA selection when focus is
    // elsewhere. Restore only this component's own selected state.
    const selectionObserver = new MutationObserver(() => {
      if (!desktop) return;
      tabs.forEach((tab, i) => {
        const value = String(i === selected);
        if (tab.getAttribute('aria-selected') !== value) tab.setAttribute('aria-selected', value);
      });
    });
    tabs.forEach(tab => selectionObserver.observe(tab, { attributes: true, attributeFilter: ['aria-selected'] }));
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => { selected = i; render(); }, options);
      tab.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          selected = i;
          render();
          return;
        }
        let next;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) {
          event.preventDefault();
          event.stopPropagation();
          tabs.forEach((t, index) => { t.tabIndex = index === next ? 0 : -1; });
          tabs[next].focus();
        }
      }, options);
    });
    toggles.forEach((toggle, i) => toggle.addEventListener('click', () => {
      if (expanded.has(i)) expanded.delete(i); else expanded.add(i);
      selected = i;
      render();
    }, options));
    const change = () => {
      const focused = document.activeElement;
      const index = tabs.indexOf(focused) >= 0 ? tabs.indexOf(focused)
        : toggles.indexOf(focused) >= 0 ? toggles.indexOf(focused)
        : panels.findIndex(p => p.contains(focused));
      mount();
      desktop = media.matches;
      if (index >= 0) selected = index;
      if (!desktop) expanded.add(selected);
      render();
      if (index >= 0 && !panels[index].contains(focused)) {
        (desktop ? tabs[index] : toggles[index]).focus({ preventScroll: true });
      }
    };
    media.addEventListener('change', change);
    const hash = () => {
      const index = panels.findIndex(p => '#' + p.id === location.hash);
      if (index < 0) return;
      selected = index; expanded.add(index); render();
      panels[index].scrollIntoView({ block: 'start', behavior: 'auto' });
    };
    window.addEventListener('hashchange', hash, options);
    root.addEventListener('pdp:destroy', () => {
      if (destroyed) return;
      destroyed = true;
      signalController.abort();
      selectionObserver.disconnect();
      reviewResize.disconnect();
      reviewInsert.disconnect();
      buyResize.disconnect();
      cancelAnimationFrame(buyFrame);
      media.removeEventListener('change', change);
    }, { once: true });
    root.querySelector('[data-pdp-choose]')?.addEventListener('click', event => {
      const form = document.querySelector('[data-bk-pdp-main] product-form form');
      if (!form) return;
      event.preventDefault();
      form.scrollIntoView({ block: 'center', behavior: 'auto' });
      const button = form.querySelector('button[type="submit"]:not(:disabled)');
      button?.focus({ preventScroll: true });
    }, options);
    render(); hash();
  };
  const init = (scope = document) => scope.querySelectorAll('[data-bk-pdp]').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-bk-pdp]').forEach(root => root.dispatchEvent(new Event('pdp:destroy')));
  });
})();
